import { showMessage } from "./toast";
import { getCredentials } from "./authHelper";
import { _toastVariants } from "../constant";

function getRequestHeaders(type) {
  let headers = {};
  switch (type) {
    case "json":
      headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      break;
    case "form":
      headers = {
        accept: "application/json",
        "access-control-allow-origin": "*",
      };
      break;
    default:
      headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      };
      break;
  }
  return headers;
}

function createQueryOrParams(object, type = "query") {
  let string = "";
  let length = Object.entries(object).length || 0;
  if (type === "query") {
    string = "?";
    Object.entries(object).forEach((item, index) => {
      string = string + item[0] + "=" + item[1];
      if (length !== index + 1) {
        string = string + "&";
      }
    });
  } else if (type === "params") {
    string = "/";
    Object.entries(object).forEach((item, index) => {
      string = string + item[1];
      if (length !== index + 1) {
        string = string + "/";
      }
    });
  }
  return string;
}

const apiRequest = async ({
  endUrl,
  method,
  headerType = "json",
  body = null,
  query = null,
  params = null,
  token = true,
  savedToken = null,
  showMsg = false,
  addOrgQry = false,
  allOrg = false,
}) => {
  let requestHeaders = getRequestHeaders(headerType);
  if (savedToken) {
    requestHeaders.Authorization = "Bearer " + savedToken;
  } else if (token) {
    /* Add token */
    requestHeaders.Authorization = "Bearer " + getCredentials();
  }
  if (params) {
    /* Add params */
    endUrl = endUrl + createQueryOrParams(params, "params");
  }
 
    /* Add query */
    if (query && typeof query === 'object') {
    const queryParams = Object.entries(query)
        .filter(([_, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => {
            if (Array.isArray(value)) {
                return `${encodeURIComponent(key)}=${encodeURIComponent(value.join(','))}`;
            } else if (value instanceof Date) {
                return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
            } else if (typeof value === 'object') {
                console.warn(`Skipping unsupported object in query: ${key}`);
                return null;
            }
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        })
        .filter(Boolean)
        .join('&');

    if (queryParams) {
        endUrl += (endUrl.includes('?') ? '&' : '?') + queryParams;
    }


  }
  const options = {
    method: method,
    headers: requestHeaders,
    timeoutInterval: 10000,
  };
  if (body) {
    options.body = headerType === "json" ? JSON.stringify(body) : body;
  }
  try {
    let fetched = await fetch(endUrl, options);
    let response = await fetched.json();
    if (response.status === 200 || response.status_code === 200) {
      /* Will modify according to api's response */
      response = {
        status: true,
        data: response.data,
        message: response.message,
      };
    } else {
      let msg =
        response?.errors?.length > 0 ? response?.errors?.[0].message : "";
      response = { status: false, data: {}, message: response.message || msg };
    }
    if (showMsg) {
      showMessage({
        variant: response?.status
          ? _toastVariants.Success
          : _toastVariants.Error,
        message: response?.message,
      });
    }
    return response;
  } catch (e) {
    if (showMsg) {
      showMessage({ variant: _toastVariants.Error, message: e.toString() });
    }
    return { status: false, data: {}, message: e.toString() };
  }
};

// const apiRequestForSurePass = async ({
//     endUrl,
//     method,
//     headerType = 'json',
//     body = null,
//     query = null,
//     params = null,
//     token = true,
//     savedToken = null,
// }) => {
//     let requestHeaders = getRequestHeaders(headerType)
//     if (savedToken) {
//         requestHeaders.Authorization = 'Bearer ' + savedToken
//     } else if (token) {
//         /* Add token */
//         requestHeaders.Authorization = 'Bearer ' + getCredentials()?.access_token
//     }
//     if (params) {
//         /* Add params */
//         endUrl = endUrl + createQueryOrParams(params, 'params')
//     }
//     if (query) {
//         /* Add query */
//         endUrl = endUrl + createQueryOrParams(query, 'query')
//     }

//     const options = {
//         method: method,
//         headers: requestHeaders,
//         timeoutInterval: 10000,
//     }
//     if (body) {
//         options.body = headerType === 'json' ? JSON.stringify(body) : body
//     }
//     try {
//         let fetched = await fetch(endUrl, options)
//         let response = await fetched.json()
//         if (
//             response.status_code === 200 &&
//             response?.success &&
//             response?.message_code === 'success'
//         ) {
//             /* Will modify according to api's response */
//             response = {
//                 status: true,
//                 data: response.data,
//                 message: response?.message,
//             }
//         } else {
//             response = {
//                 status: false,
//                 data: {},
//                 message: response?.message,
//             }
//         }
//         return response
//     } catch (e) {
//         return { status: false, data: {}, message: e.toString() }
//     }
// }

// const apiRequestForMediaFiles = async ({
//     endUrl,
//     method,
//     headerType = 'json',
//     body = null,
//     query = null,
//     params = null,
//     token = true,
//     savedToken = null,
//     showMsg = false
// }) => {
//     let requestHeaders = getRequestHeaders(headerType)
//     if (savedToken) {
//         requestHeaders.Authorization = 'Bearer ' + savedToken
//     } else if (token) {
//         /* Add token */
//         requestHeaders.Authorization = 'Bearer ' + getCredentials()?.access_token
//     }
//     if (params) {
//         /* Add params */
//         endUrl = endUrl + createQueryOrParams(params, 'params')
//     }
//     if (query) {
//         /* Add query */
//         endUrl = endUrl + createQueryOrParams(query, 'query')
//     }

//     const options = {
//         method: method,
//         headers: requestHeaders,
//         timeoutInterval: 10000,
//     }
//     if (body) {
//         options.body = headerType === 'json' ? JSON.stringify(body) : body
//     }
//     try {
//         let response = {}
//         let fetched = await fetch(endUrl, options)

//         const blob = await fetched.clone().blob()
//         if (blob.type === "application/json") {
//             console.log(response, "blob.type")
//             response = await fetched.clone().json()
//             let msg = response?.errors?.length > 0 ? response?.errors?.[0].message : ''

//             if (response.status === 200 || response.status_code === 200) {
//                 /* Will modify according to api's response */
//                 response = {
//                     status: true,
//                     data: response.data,
//                     message: response.message,
//                     errorCode: response.errorCode
//                 }
//             } else {
//                 response = { status: false, data: {}, message: response.message || msg, code: response.errorCode }
//             }
//             if (showMsg) {
//                 showMessage({
//                     variant: response?.status
//                         ? _toastVariants.Success
//                         : _toastVariants.Error,
//                     message: response?.message || msg,
//                 })
//             }
//         } else {
//             const url = window.URL.createObjectURL(new Blob([blob]))
//             if (url) {
//                 response = { status: true, data: { url }, message: "File get successfully" }
//             } else {
//                 response = { status: false, data: {}, message: "Something went wrong." }
//             }
//         }
//         return response
//     } catch (e) {
//         if (showMsg) {
//             showMessage({ variant: _toastVariants.Error, message: e.toString() })
//         }
//         return { status: false, data: {}, message: e.toString() }
//     }
// }

export { apiRequest, createQueryOrParams };
